module.exports = __webpack_public_path__ + "static/koandcoanimation-44f91dfb62d1332dd018669826815259.mp4";